import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'ef-rows-per-page',
    templateUrl: './rows-per-page.component.html',
    styleUrls: ['./rows-per-page.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RowsPerPageComponent),
            multi: true
        }
    ],
    standalone: false
})
export class RowsPerPageComponent implements AfterViewInit, ControlValueAccessor  {
   @ViewChild('pageCount', { static: true }) pageCount;
  private formControlChanged: Function;
  private formControlTouched: Function;
  ngAfterViewInit (): void {
    this.pageCount.registerOnChange(this.formControlChanged);
    this.pageCount.registerOnTouched(this.formControlTouched);
  }
  writeValue (obj: any): void {
    if (this.pageCount) {this.pageCount.writeValue(obj); }
  }
  registerOnChange (fn: any): void {
    this.formControlChanged = fn || function() {};
  }
  registerOnTouched (fn: any): void {
    this.formControlTouched = fn || function() {};
  }
  setDisabledState?(isDisabled: boolean): void {
    this.pageCount.setDisabledState(isDisabled);
  }

  constructor() {
   }

}
